declare var SVGExtractor: any;
declare var SVG2IMG: any;

import { Injectable } from '@angular/core';
import {CrudDataGenericService} from '../shared/services';
import {HttpClient} from '@angular/common/http';
import '../../assets/libs/auxiliaries.js';

@Injectable()
export class OffersService extends CrudDataGenericService <any> {
  url = '/offer/';


  constructor(protected http: HttpClient) {
    super(http);
  }

  extractSVG(svg){
    var margin = {top: 0, right: 18, bottom: 10, left: 55};
    var ext_svg = SVGExtractor(svg);
    var imgdata = SVG2IMG(ext_svg, 630, 340, margin, 'svg');
    return imgdata.src;
  }

}



// WEBPACK FOOTER //
// ./src/app/offers/offers.service.ts